export default "__VITE_ASSET__87397270__"